import { render } from "./DepositResult.vue?vue&type=template&id=17b600d4&scoped=true"
import script from "./DepositResult.vue?vue&type=script&lang=js"
export * from "./DepositResult.vue?vue&type=script&lang=js"

import "./DepositResult.vue?vue&type=style&index=0&id=17b600d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b600d4"]])

export default __exports__